import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";

export const useUploadVesselGeneralInfo = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const vesselId = localStorage.getItem('vesselId');  

  const uploadVesselInfo = async (formData) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/vessel/upload/vesselInformation/${vesselId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(formData),
        }
      );

      if (!response.ok) {
        const errorResponse = await response.json(); 
        throw new Error(errorResponse.message); 
      }

      return response.json(); 
    } catch (error) {
      throw new Error(error.message); 
    }
  };

  return useMutation(uploadVesselInfo, {
    onSuccess: () => {
      queryClient.invalidateQueries("vesselData");
      navigate("/vesselimages");
    },
  });
};
